"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var Row = _styledComponents.default.div.withConfig({
  displayName: "ListRow__Row",
  componentId: "sc-slic1f-0"
})(["display:flex;align-items:center;gap:", ";width:100%;"], _styles.spacing.m);
var ListRow = function ListRow(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    dataCy = _ref['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Row, {
    onClick: onClick,
    "data-cy": dataCy,
    children: children
  });
};
ListRow.defaultProps = {};
var _default = exports.default = ListRow;